import { Stack, xcss } from '@atlaskit/primitives';
import JiraIssueLink from '@databases/content-link/JiraIssueLink';
import { type DatabaseFieldType } from '@databases/types/database';
import { isNonEmptyJiraIssueValue } from '@databases/utils/database/field-types/jiraIssue';
import React, { type FunctionComponent, useMemo } from 'react';

import { type ViewComponentProps } from './types.ts';

const containerStyles = xcss({
  listStyle: 'none',
  padding: '0',
  gap: 'space.050'
});

const JiraIssueValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.JIRA_ISSUE>
> = ({ field, value, showDisabledValue }) => {
  const issues = useMemo(
    () =>
      value.flatMap((v) => {
        if (isNonEmptyJiraIssueValue(v)) {
          return [
            {
              _id: v._id,
              cloudId: field.settings.cloudId,
              serverId: field.settings.jiraServerId,
              key: v.key
            }
          ];
        } else {
          return [];
        }
      }),
    [field.settings.cloudId, field.settings.jiraServerId, value]
  );

  return (
    <Stack as="ul" xcss={containerStyles}>
      {issues.map((issue) => (
        <li key={issue._id}>
          <JiraIssueLink
            issue={issue}
            useSmartLink
            showDisabledValue={showDisabledValue}
          />
        </li>
      ))}
    </Stack>
  );
};

export default JiraIssueValueView;
